var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-332.000000, -380.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(0.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(15.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8FD4\\u56DE",
    transform: "translate(327.000000, 102.000000) rotate(-270.000000) translate(-327.000000, -102.000000) translate(317.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gengduo-8",
    transform: "translate(3.339506, 8.518519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.48148148,0 C2.29968111,0 2.96296296,0.663281852 2.96296296,1.48148148 C2.96296296,2.29968111 2.29968111,2.96296296 1.48148148,2.96296296 C0.663281852,2.96296296 0,2.29968111 0,1.48148148 C0,0.663281852 0.663281852,0 1.48148148,0 Z M6.66666667,0 C7.4848663,0 8.14814815,0.663281852 8.14814815,1.48148148 C8.14814815,2.29968111 7.4848663,2.96296296 6.66666667,2.96296296 C5.84846704,2.96296296 5.18518519,2.29968111 5.18518519,1.48148148 C5.18518519,0.663281852 5.84846704,0 6.66666667,0 Z M11.8518519,0 C12.6700515,0 13.3333333,0.663281852 13.3333333,1.48148148 C13.3333333,2.29968111 12.6700515,2.96296296 11.8518519,2.96296296 C11.0336522,2.96296296 10.3703704,2.29968111 10.3703704,1.48148148 C10.3703704,0.663281852 11.0336522,0 11.8518519,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.1773f27b2a701b4ae6eafa113092be7f.svg";
export { ForwardRef as ReactComponent };